// src/components/ui/Alert.jsx
// Использование:
//   <Alert variant="success" onClose={() => setMsg(null)}>Договор подписан!</Alert>
//   <Alert variant="error" onClose={() => setMsg(null)}>Ошибка загрузки: 403</Alert>
//   <Alert variant="warning">Предупреждение без кнопки закрытия</Alert>
//   <Alert variant="info">Информационное сообщение</Alert>
//
//   // Управляемое: показываем только когда msg не null
//   {msg && <Alert variant={msg.type} onClose={() => setMsg(null)}>{msg.text}</Alert>}

import React from 'react';
import { CheckCircle2, AlertTriangle, Info, X, XCircle } from 'lucide-react';
import { Button } from './Button';

const variants = {
  success: {
    wrap: 'bg-emerald-500/10 border-emerald-500/20 text-emerald-400',
    icon: CheckCircle2,
  },
  error: {
    wrap: 'bg-red-500/10 border-red-500/20 text-red-400',
    icon: XCircle,
  },
  warning: {
    wrap: 'bg-amber-500/10 border-amber-500/20 text-amber-400', // добавлен: предупреждения
    icon: AlertTriangle,
  },
  info: {
    wrap: 'bg-blue-500/10 border-blue-500/20 text-blue-400',    // добавлен: информационные сообщения
    icon: Info,
  },
};

export const Alert = ({
  children,
  variant = 'info',
  onClose,
  className = '',
}) => {
  const cfg = variants[variant] ?? variants.info;
  const Icon = cfg.icon;

  return (
    <div
      className={`
        p-4 rounded-2xl border
        font-bold text-sm
        flex items-center gap-3
        ${cfg.wrap}
        ${className}
      `}
    >
      <Icon size={16} className="flex-shrink-0" />
      <span className="flex-1">{children}</span>
      {onClose && (
        <Button
          variant="icon"
          onClick={onClose}
          className="ml-auto opacity-60 hover:opacity-100 flex-shrink-0"
        >
          <X size={14} />
        </Button>
      )}
    </div>
  );
};